/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Brokers_HintInputs */

const cs_calendar_brokers_hint = /** @type {(inputs: Calendar_Brokers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vícenásobný výběr pro porovnání rozvrhů. Prázdné = všichni.`)
};

const en_calendar_brokers_hint = /** @type {(inputs: Calendar_Brokers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-select to compare schedules. Empty = everyone.`)
};

/**
* | output |
* | --- |
* | "Multi-select to compare schedules. Empty = everyone." |
*
* @param {Calendar_Brokers_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers_hint = /** @type {((inputs?: Calendar_Brokers_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Brokers_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers_hint(inputs)
	return cs_calendar_brokers_hint(inputs)
});